<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.code }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PromocodeTabLinks />
                    <PromocodeUpsertForm
                        class="mt-4 ml-2 ml-2"
                        :entity.sync="entity"
                        @success="$router.push(`/promocodes/${$route.params.id}`)"
                        @deleted="$router.push(`/promocodes/${$route.params.id}`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import PromocodeTabLinks from '@/components/promocodes/PromocodeTabLinks';
    import PromocodeUpsertForm from '@/components/promocodes/PromocodeUpsertForm';

    export default {
        name: 'PromocodeEdit',

        components: {
            PromocodeTabLinks,
            PromocodeUpsertForm,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/promocodes/${id}`)).data;
            },
        },
    };
</script>
